// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    // url:'http://10.10.9.26:7361/v1/',
    // url: 'https://10.10.8.87:7361/v1/',
    // serverUrl: 'https://nookstg.appskeeper.com',
    serverUrl: 'https://api-staging.nook.com.ph',
    //  serverUrl: 'https://webapi.nook.com.ph',
    get apiUrl(): string {
        return `${this.serverUrl}/v1`;
    },
    get url(): string {
        return `${this.apiUrl}/admin/`;
    },
    publicToken: 'dG9raWFwcDp0b2tpYXBw',
    config: {
        BUCKET_NAME: 'nook-app',
        AWS_ACCESS_KEY: 'AKIA6ODTXG53J7AZNCXY',
        AWS_SECRET_KEY: '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',
        REGION: 'ap-northeast-1'
      },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
